export default {
  default: () => import("/github/workspace/layouts/default.vue").then(m => m.default || m)
}